// Shared by native links, the web router and Node-based release tooling.
function validStoryId(value) {
  return Number.isInteger(value) && value > 0 && value <= 2147483647;
}

function unsubscribeStoryId(search) {
  if (typeof search !== 'string') return null;
  const params = new URLSearchParams(search);
  const values = params.getAll('story');
  if (values.length !== 1 || Array.from(params.keys()).some(key => key.startsWith('story['))
    || values[0].trim() !== values[0] || !/^[1-9]\d*$/.test(values[0])) return null;
  const id = Number(values[0]);
  return validStoryId(id) ? id : null;
}

function unsubscribeSearch(storyId) {
  return validStoryId(storyId) ? `?story=${storyId}` : '';
}

// The standalone Safari banner serializes these functions with their shared
// validator so it can run before React without a separate validation policy.
module.exports = { validStoryId, unsubscribeStoryId, unsubscribeSearch };
